/**
 * Concept Archetype
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */

import Axios from 'axios';
import _ from 'lodash'

const baseController = 'presentacionconcept',
    articuloController = 'presentacionarticuloconcept';

const baseIndex = baseController + '/index'

const archetype = [
    // [hidden|number|price|phone|textarea|positivo|password|email]
    { key: 'id_pk', type: 'hidden' },
    { key: 'imagen_uri', type: 'storedimg' },
    [
        { key: 'elemento_id_fk', type: 'select', label: 'Ingrediente/Artículo', readonly: true },
    ],

    [
        { key: 'tipopresentacion', type: 'select', label: 'Tipo presentación' },
        { key: 'nombre', label: 'Presentación', type: 'positive' },
        { key: 'idunidad_fk', type: 'select', label: 'Unidad' },
    ],
    null,
    [
        { key: 'idmarca_fk', type: 'select', label: 'Marca' },
        { key: 'proveedor_asignado_id', type: 'select', label: 'Proveedor asignado' },
    ],
    null,
    [
        { key: 'costo', type: 'price', default: '0.00' },
        { key: 'precio', type: 'price', default: '0.00' },
        { key: 'precio_restaurante', type: 'price', default: '0.00' },
    ],
    null,
    [
        { key: 'inventario', type: 'decimal', default: '0' },
        {
            key: 'iva', type: 'select', label: 'IVA', default: '0.00', options: [
                { value: '0.00', text: 'Sin IVA' },
                { value: '16.00', text: 'Con IVA' },
            ]
        },
        {
            key: 'radio_rendimiento', type: 'select', default: '1', options: [
                { value: 1, text: '100%' },
                { value: 0.9, text: '90%' },
                { value: 0.8, text: '80%' },
                { value: 0.7, text: '70%' },
                { value: 0.6, text: '60%' },
                { value: 0.5, text: '50%' },
                { value: 0.4, text: '40%' },
                { value: 0.3, text: '30%' },
            ]
        },
    ],
    null,
    { key: 'descripcion', type: 'textarea', label: 'Descripción' },
    { key: 'estatus', type: 'hidden', default: '1' },
    { key: 'id_ultimo_usuario_fk', type: 'hidden' },
    { key: 'ultima_actualizacion', type: 'hidden' },
    { key: 'codigo', type: 'hidden' },

    { key: 'visible_en_zero', type: 'hidden' },
    { key: 'visible_en_tienda', type: 'hidden' },
    { key: 'promocionado_en_tienda', type: 'hidden' },
    { key: 'promocionado_en_categoria', type: 'hidden' }
];

const captions = [
    { key: 'imagen_uri', label: 'Imágen' },
    { key: 'presentacion', sortable: true },
    { key: 'marca', sortable: true },
    { key: 'titulo_extendido', sortable: true },
    { key: 'categoria', label: 'Categoría', sortable: true },
    { key: 'inventario', sortable: true },
    { key: 'costo',  sortable: true },
    { key: 'precio',  sortable: true },
    { key: '_' },
    { key: 'proveedorAsignado', label: 'Proveedor', sortable: true },
]

let automodalHandler = (conceptId, tipo) => {
    let str = ((parseInt(tipo) == 1) ? baseController : articuloController) + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    return str;
}

let uiAsidesFetch = async () => {
    const response = await Axios.get('ui/getProveedoresMarcasTiposYUnidades');

    if (!response.status) {
        return {}
    }

    return response.data
}

let captionsExceptBy = (bannedMatrix) => {
    return _.filter(captions, item => {
        return (bannedMatrix.indexOf(item.key) == -1)
    })
}

export {
    archetype,
    captions,
    baseIndex,
    automodalHandler,
    uiAsidesFetch,
    captionsExceptBy
}